import logger from 'utils/logger.util';

const L = logger('fromObjectToValues');

const fromObjectToValues = (object) => {
  try {
    return Object.values(object);
  } catch (e) {
    L.warn('()', e);
    return [];
  }
};

// noinspection JSUnusedGlobalSymbols
export default fromObjectToValues;
